import React, { useEffect } from 'react';
import './ConectaTuCaminoPage.css';
import Header from './Header';
import AnimatedBackground from './AnimatedBackground';

const ConectaTuCaminoPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const go = (path) => {
    window.history.pushState({}, '', path);
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <div className="conecta-page">
      <Header />
      <AnimatedBackground particleCount={5} staticCount={2} />
      <section className="conecta-hero">
        <div className="conecta-container conecta-hero-inner">
          <span className="conecta-kicker">Conecta con tu camino</span>
          <h1>Psicología orientada al propósito y coaching para tus metas</h1>
          <p className="conecta-lead">
            Acompañamos procesos conscientes cuando buscas orden emocional, claridad ante decisiones o un plan ejecutable sin
            perder tu esencia —con profesionales que ya trabajan aliados a nuestra causa.
          </p>
          <button type="button" className="conecta-btn-primary" onClick={() => go('/contacto')}>
            Coordinar primera conversación
          </button>
        </div>
      </section>

      <main className="conecta-main conecta-container">
        <section className="conecta-grid-two">
          <article className="conecta-card-pro">
            <div className="conecta-card-icon"><i className="fas fa-brain" /></div>
            <h2>Cuidado psicológico</h2>
            <p>
              Espacio confidencial para transitos personales —estrés recurrente, duelo, reorganización vida laboral/amorosa— desde
              enfoques humanistas y prácticos, sin etiquetar antes de comprender bien tu mapa vital.
            </p>
          </article>
          <article className="conecta-card-pro">
            <div className="conecta-card-icon"><i className="fas fa-route" /></div>
            <h2>Coaching ejecutivo & vida</h2>
            <p>
              Si tu reto tiene nombre de proyecto (emprender, migrar hábitos, liderazgo nuevo o metas físicas conscientes):
              formulamos objetivos SMART amables, checkpoints quincenales y acciones cotidianas sostenibles.
            </p>
          </article>
        </section>
        <p className="conecta-footnote">
          Las sesiones pueden ser presenciales (según disponibilidad en Colombia) u online bien estructuradas. Agenda vía&nbsp;
          <button type="button" className="conecta-inline-link" onClick={() => go('/contacto')}>
            Contacto directo</button>; detallamos servicio, formato y honorarios antes de iniciar cualquier proceso.
        </p>
      </main>
    </div>
  );
};

export default ConectaTuCaminoPage;
